import { Actions } from "../Actions/Actiontypes";

const initialState = {
  Component: null,
};

function SideNavReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.ADD_SIDE_COMPONENT: {
      return {
        ...state,
        Component: action.payload,
      };
    }
    default:
      return state;
  }
}

export default SideNavReducer;
